module.exports = __webpack_public_path__ + "assets/images/calendar-plus-icon.bd05c429e70755429c3c106c834f2c33.svg";